import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';
import Calendar from 'primevue/calendar';
import Message from 'primevue/message';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';  
import InputText from 'primevue/inputtext';
import Tooltip from 'primevue/tooltip';
import DataView from 'primevue/dataview';
import 'primevue/resources/themes/saga-blue/theme.css'       //theme
import 'primevue/resources/primevue.min.css'                 //core css
import 'primeicons/primeicons.css';                         //icons
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './styles/forms.scss'
import VueApexCharts from "vue3-apexcharts";

const app= createApp(App)
    app.use(PrimeVue,{ripple: true})
    app.use(store)
    app.use(router)
    app.use(ToastService)
    app.use(VueApexCharts);
    app.directive('tooltip', Tooltip);
    app.component('Toast',Toast)
    app.component('Calendar',Calendar)
    app.component('DataTable',DataTable)
    app.component('DataView',DataView)
    app.component('Column',Column)
    app.component('InputText',InputText)
    app.component('ColumnGroup',ColumnGroup)
    app.component('Message',Message)
    // app.component('apexchart',VueApexCharts)
    .mount('#app')
